// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"284":"ba1712fc","893":"7bf94aed"}[chunkId] || chunkId) + "." + {"284":"13d4bdbcd8c95da3","456":"5117a3217b17b227","567":"8d27e78fbeceaa75","893":"a1778d43026bc957"}[chunkId] + ".js";
};